export default __webpack_public_path__ + "static/media/credible.135d66c1.png";